/**
 * Countdown timer
 *
 * Times out session on Payment page
 * 
 */
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IS_PROD } from '../../../data/Data';
import './CountdownTimer.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CountdownTimer = props => {
  const {
    expired,
    reload,
    setPageExpired
  } = props;
  const search = new URLSearchParams(window.location.search);
  const searchMax = parseInt(search.get('max'));
  const max = !IS_PROD && searchMax && searchMax >= 1 && searchMax < 5400 ? searchMax : 90 * 60; // 90 mins timeout
  const [time, setTime] = useState(max); // max time is measured in seconds
  const [display, setDisplay] = useState(null);
  useEffect(() => {
    let timeoutId;
    if (time <= -1) {
      setPageExpired();
      setTime(0);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    timeoutId = setTimeout(() => {
      const newTime = time - 1;
      const hours = parseInt(time / 3600);
      let minutes = parseInt(time / 60) - hours * 60;
      let seconds = time - (hours * 60 + minutes) * 60;
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      setTime(newTime);
      setDisplay(`${hours}:${minutes}:${seconds}`);
    }, 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [setPageExpired, setTime, setDisplay, time]);
  return expired ? /*#__PURE__*/_jsxs("div", {
    className: "CountdownTimer",
    onClick: reload,
    children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: 'triangle-exclamation',
      inverse: true
    }), /*#__PURE__*/_jsxs("div", {
      className: "top-text",
      children: [expired ? 'Your session has expired' : 'You have', /*#__PURE__*/_jsx("div", {
        className: "click",
        children: "Click to reload the page to continue your transaction"
      })]
    })]
  }) : /*#__PURE__*/_jsx("div", {
    className: "CountdownTimer hidden",
    children: display
  });
};
export default CountdownTimer;